import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";
import { MIN_MORNITOR_WIDTH } from "../../constants";

interface Props {
  notRequired?: boolean;
  isSecondDepth?: boolean;
}

const FormLabel: React.FC<Props> = ({
  notRequired,
  isSecondDepth,
  children,
}) => {
  return (
    <StyledLabelWrapper isSecondDepth={isSecondDepth}>
      {children}
      <StyledSpan>{!notRequired && "*"}</StyledSpan>
    </StyledLabelWrapper>
  );
};
export default FormLabel;
const StyledLabelWrapper = styled.div<Props>`
  ${({ isSecondDepth }) =>
    isSecondDepth ? theme.typo.heading.b20 : theme.typo.heading.b14};
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    max-width: 320px;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
  }
  margin-bottom: 16px;
  line-height: 32px;
`;
const StyledSpan = styled.span`
  color: red;
  margin-left: 4px;
  line-height: 32px;
`;
